module.exports = __webpack_public_path__ + "static/why-video-bg-3c558c48dd3d768b0acc46d619570ee0.png";